<template>
    <div>
        <v-row>
            <v-col col="12" lg="6" md="8">
                <v-card>
                    <v-card-title>Vaihda salasana</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="submit" ref="formRef">
                            <v-text-field outlined :label="'Nykyinen salasana'" type="password" :rules="[required]"
                                v-model="oldPassword"></v-text-field>
                            <v-text-field outlined :label="'Uusi salasana'" type="password" :rules="[required]"
                                v-model="newPassword"></v-text-field>
                            <v-text-field outlined :label="'Vahvista uusi salasana'" type="password"
                                :rules="[matchPassword]" v-model="confirmPassword"
                                :hint="'Salasanan tulee olla vähintään 8 merkkiä pitkä ja sisältää iso kirjain, pieni kirjain sekä numero'"
                                persistent-hint></v-text-field>
                            <br>
                            <v-btn type="submit" color="primary">Vaihda salasana</v-btn>
                        </v-form>
                        <v-alert type="success" class="mt-5" v-if="passwordChanged">
                            Salasana vaihdettiin onnistuneesti
                        </v-alert>
                        <v-alert type="error" class="mt-5" v-if="failed">
                            {{ error }}
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from "@/api";
import { useTranslations } from "@/@core/libs/i18n";
import { ref } from "@vue/composition-api";

import {
    mdiClose,
    mdiPoll,
    mdiPencil,
    mdiFormatQuoteClose,
    mdiCalendar,
} from "@mdi/js";
import { required } from "@/@core/utils/validation";


export default {

    setup() {

        const { t } = useTranslations();
        const formRef = ref(null);
        const oldPassword = ref('');
        const newPassword = ref('');
        const confirmPassword = ref('');
        const failed = ref(false);
        const error = ref('');
        const passwordChanged = ref(false);

        const submit = async () => {
            passwordChanged.value = false;
            failed.value = false;
            error.value = "";

            const valid = formRef.value.validate();
            if (valid) {
                const res = await api.changePassword(oldPassword.value, newPassword.value);
                if (res.ok) {
                    passwordChanged.value = true;
                }
                else {
                    failed.value = true;
                    error.value = res.data;
                }
                oldPassword.value = "";
                newPassword.value = "";
                confirmPassword.value = "";
            }
        };

        const matchPassword = v => v === newPassword.value ? true : 'Salasanat eivät täsmää';

        return {
            formRef,
            matchPassword,
            submit,
            required,
            oldPassword,
            newPassword,
            passwordChanged,
            failed,
            confirmPassword,
            t,
            error,
            icons: {
                mdiClose,
                mdiPoll,
                mdiPencil,
                mdiFormatQuoteClose,
                mdiCalendar,
            },
        };
    },
};
</script>